import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as i0 from "@angular/core";
var MqttdashboardComponent = /** @class */ (function () {
    function MqttdashboardComponent() {
        var _this = this;
        this.ELEMENT_DATA = [];
        var CLIENT_ID = 'emqx_nodejs_' + Math.random().toString(16).substring(2, 8);
        this.client = new Paho.MQTT.Client('broker.emqx.io', 8083, CLIENT_ID);
        this.client.onConnectionLost = function (responseObject) {
            if (responseObject.errorCode !== 0) {
                console.log("Connection lost: " + responseObject.errorMessage);
            }
        };
        this.client.onMessageArrived = function (message) {
            console.log("Message Arrived: " + message.payloadString);
            // Update message handling as needed
            var currentDate = new Date(); // Current date and time
            var year = currentDate.getFullYear();
            var month = currentDate.getMonth() + 1; // Adding 1 to adjust zero-based month
            var day = currentDate.getDate();
            var hours = currentDate.getHours();
            var minutes = currentDate.getMinutes();
            var seconds = currentDate.getSeconds();
            // Convert each component to a string and pad single-digit values with leading zeros if needed
            var dateString = year + "-" + month.toString().padStart(2, '0') + "-" + day.toString().padStart(2, '0');
            var timeString = hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0');
            var dateTimeString = dateString + " " + timeString;
            var data = JSON.parse(message.payloadString);
            var updateData = tslib_1.__assign({ Timestamp: dateTimeString }, data);
            // Combine date and time strings into a single string
            _this.tableheading = Object.keys(updateData);
            var jsonValuesData = updateData;
            Object.keys(jsonValuesData).forEach(function (key) {
                if (jsonValuesData[key] == -375) {
                    jsonValuesData[key] = 0;
                }
                if (key == "AI-1") {
                    jsonValuesData[key] = Number(jsonValuesData[key]) / 10;
                }
            });
            _this.ELEMENT_DATA.push(jsonValuesData);
            if (_this.ELEMENT_DATA.length > 1 && !_this.tableheading.includes("MODBUS Error")) {
                _this.updateData();
            }
        };
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        var options = {
            userName: 'deep',
            password: 'admin',
            onSuccess: function () {
                console.log("Connected to MQTT Broker");
                _this.client.subscribe('ethModbus');
            },
            onFailure: function (errorMessage) {
                console.log("Failed to connect: " + errorMessage.errorMessage);
            }
        };
        this.client.connect(options);
    }
    MqttdashboardComponent.prototype.ngOnInit = function () {
    };
    MqttdashboardComponent.prototype.updateData = function () {
        this.dataSource.data = this.ELEMENT_DATA.slice().reverse();
    };
    MqttdashboardComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MqttdashboardComponent_Factory() { return new MqttdashboardComponent(); }, token: MqttdashboardComponent, providedIn: "root" });
    return MqttdashboardComponent;
}());
export { MqttdashboardComponent };
